import { z } from 'zod';

import { LoanId } from '../BrandedIds';

export const BaseLoanIdSideEffect = z.object({
  loanId: LoanId,
});
